"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _auxiliaryNav = _interopRequireDefault(require("../auxiliary-nav"));
var _hamburgerNavItem = _interopRequireDefault(require("./hamburger-nav-item"));
var _pushViewButton = _interopRequireDefault(require("./push-view-button"));
require("./hamburger-nav.css");
var _excluded = ["subNavItems"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var PrimaryHamburgerNavPanel = function PrimaryHamburgerNavPanel(_ref) {
  var accountButton = _ref.accountButton,
    accountNav = _ref.accountNav,
    AuxiliaryContent = _ref.auxiliaryContent,
    closeHamburgerNav = _ref.closeHamburgerNav,
    findAStorePin = _ref.findAStorePin,
    HamburgerNavFooter = _ref.hamburgerNavFooter,
    isUserAuthenticated = _ref.isUserAuthenticated,
    joinNowButton = _ref.joinNowButton,
    navItems = _ref.navItems,
    pushViewButtonLabels = _ref.pushViewButtonLabels,
    setReturnFocusElement = _ref.setReturnFocusElement,
    setSecondaryPanelToOpen = _ref.setSecondaryPanelToOpen,
    signInButton = _ref.signInButton,
    signOutButton = _ref.signOutButton;
  var addPushViewButton = function addPushViewButton(pushViewBtnItem, key) {
    var _onClick = pushViewBtnItem.onClick;
    return /*#__PURE__*/_react["default"].createElement(_pushViewButton["default"], _extends({
      key: key,
      pushViewButtonLabels: pushViewButtonLabels
    }, pushViewBtnItem, {
      onClick: function onClick(e) {
        setSecondaryPanelToOpen(pushViewBtnItem.children);
        setReturnFocusElement(e.target);
        _onClick && _onClick(e);
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", null, navItems.map(function (item, i) {
    var subNavItems = item.subNavItems,
      otherProps = _objectWithoutProperties(item, _excluded);
    var hasSubNavItems = subNavItems && subNavItems.length;
    if (hasSubNavItems) {
      return addPushViewButton(otherProps, i);
    }
    return /*#__PURE__*/_react["default"].createElement(_hamburgerNavItem["default"], _extends({
      closeHamburgerNav: closeHamburgerNav,
      key: i
    }, otherProps));
  }), isUserAuthenticated && accountNav && addPushViewButton(_objectSpread(_objectSpread({}, accountNav), {}, {
    addRule: true
  }))), /*#__PURE__*/_react["default"].createElement(_auxiliaryNav["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    auxiliaryContent: AuxiliaryContent,
    closeHamburgerNav: closeHamburgerNav,
    findAStorePin: findAStorePin,
    isUserAuthenticated: isUserAuthenticated,
    joinNowButton: joinNowButton,
    layout: "mobile",
    signInButton: signInButton,
    signOutButton: signOutButton
  })), HamburgerNavFooter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-block py3 px5",
    onClick: closeHamburgerNav
  }, /*#__PURE__*/_react["default"].createElement(HamburgerNavFooter, null)));
};
PrimaryHamburgerNavPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  accountNav: _propTypes["default"].object,
  isUserAuthenticated: _propTypes["default"].bool,
  navItems: _propTypes["default"].array,
  closeHamburgerNav: _propTypes["default"].func,
  setSecondaryPanelToOpen: _propTypes["default"].func,
  setReturnFocusElement: _propTypes["default"].func,
  auxiliaryContent: _propTypes["default"].elementType,
  hamburgerNavFooter: _propTypes["default"].elementType
} : {};
var _default = exports["default"] = PrimaryHamburgerNavPanel;